import styled from "styled-components"

export default function ProductPolicy({
  shippingName,
  price,
  refundPrice,
  shippingPolicy,
  refundPolicy,
}) {
  return (
    <ProductPolicySection>
      <ContentSection>
        <SectionTitle>배송정보</SectionTitle>
        <TableForm>
          <TableRow>
            <TableHeader>배송방법</TableHeader>
            <TableContent>순차배송</TableContent>
          </TableRow>
          <TableRow>
            <TableHeader>배송사</TableHeader>
            <TableContent>{shippingName}</TableContent>
          </TableRow>
          <TableRow>
            <TableHeader>배송비</TableHeader>
            <TableContent>
              <ShippingPrice>{price}원</ShippingPrice>
              <br />
              {`${shippingPolicy}`}
            </TableContent>
          </TableRow>
          <TableRow>
            <TableHeader>배송기간</TableHeader>
            <TableContent>
              {`- 상품별로 상품의 특성 및 배송지에 따라 배송유형 및 소요기간이 달라집니다.`}
              <br />
              {`- 동일 브랜드의 상품이라도 상품별 출고일시가 달라 각각 배송될 수 있습니다.`}
              <br />
              {`- 도서 산간 지역 등은 배송에 3-5일에 더 소요될 수 있습니다.`}
              <br />
              {`- 천재지변, 물량 수급 변동 등 예외적인 사유 발생 시, 다소 지연될 수 있는 점 양해 부탁드립니다.`}
            </TableContent>
          </TableRow>
        </TableForm>
      </ContentSection>
      <ContentSection>
        <SectionTitle>교환/반품 안내</SectionTitle>
        {refundPrice && (
          <TableRow>
            <TableHeader>
              교환/반품 비용
              <br />
              (왕복)
            </TableHeader>
            <TableContent>
              <ShippingPrice>{refundPrice}원</ShippingPrice>
              <br />
              {`${refundPolicy}`}
            </TableContent>
          </TableRow>
        )}
        <TableRow>
          <TableHeader>{`교환/반품 신청\n기준일`}</TableHeader>
          <TableContent>
            {`- 단순변심에 의한 교환/반품은 제품 수령 후 7일 이내 까지, 교환/반품 제한사항에 해당하지 않는 경우에만 가능(배송비용과 교환/반품 비용 왕복배송비 고객 부담)`}
            <br />
            {`- 상품의 내용이 광고의 내용과 다른 경우에는 상품을 수령한 날부터 3개월 이내, 그 사실을 안 날 또는 알 수가 있었던 날부터 30일 이내에 청약철회 가능`}
          </TableContent>
        </TableRow>
      </ContentSection>
      <ContentSection>
        <SectionTitle>교환/반품 제한사항</SectionTitle>
        <TableRow>
          <TableContent>
            {`- 주문/제작 상품의 경우, 상품의 제작이 이미 진행된 경우`}
            <br />
            {`- 상품 포장을 개봉 및 사용하여 상품의 가치가 훼손된 경우 (단, 내용 확인을 위한 포장 개봉의 경우는 예외) `}
            <br />
            {`- 고객의 사용, 시간경과, 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우`}
            <br />
            {`- 세트상품 일부 사용, 구성품을 분실하였거나 취급 부주의로 인한 파손/고장/오염으로 재판매 불가한 경우`}
            <br />
            {`- 모니터 해상도의 차이로 인해 색상이나 이미지가 실제와 달라, 고객이 단순 변심으로 교환/반품을 무료로 요청하는 경우`}
            <br />
            {`- 제조사의 사정 (신모델 출시 등) 및 재료 가격 변동 등에 의해 무료 교환/반품으로 요청하는 경우`}
          </TableContent>
        </TableRow>
      </ContentSection>
      <ContentSection>
        <SectionTitle>카테고리별 교환/반품 제한사항</SectionTitle>
        <TableRow>
          <TableHeader>의류/잡화</TableHeader>
          <TableContent>
            {`- 상품의 택(TAG) 제거, 라벨 및 상품 훼손, 구성품 누락으로 상품의 가치가 현저히 감소된 경우 `}
          </TableContent>
        </TableRow>
        <TableRow>
          <TableHeader>
            계절상품/식품/
            <br />
            화장품
          </TableHeader>
          <TableContent>
            {`- 신선냉동 식품의 단순변심의 경우`}
            <br />
            {`- 뷰티 상품 이용 시 트러블 (알러지, 붉은 반점, 가려움, 따가움)이 발생하는 경우, 진료확인서 및 소견서 등을 증빙하면 환불 가능(제반비용 고객부담)`}
          </TableContent>
        </TableRow>
      </ContentSection>
    </ProductPolicySection>
  )
}

const ProductPolicySection = styled.div`
  padding-left: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-top: calc(100vw * (29 / 375));
  overflow-y: scroll;
`

const ContentSection = styled.div`
  border-bottom: 1px solid #efefef;
  padding-bottom: calc(100vw * (22 / 375));
  margin-bottom: calc(100vw * (22 / 375));

  &:last-child {
    border-bottom: none;
  }
`

const SectionTitle = styled.h3`
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (22 / 375));
`

const TableForm = styled.div``

const TableRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: calc(100vw * (12 / 375));
`

const TableHeader = styled.span`
  width: calc(100vw * (81 / 375));
  min-width: calc(100vw * (81 / 375));
  margin-right: calc(100vw * (12 / 375));
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
`

const TableContent = styled.span`
  font-weight: 400;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (18 / 375));
  color: #7f7f7f;
  white-space: pre-line;
`
const ShippingPrice = styled.div`
  color: #7f7f7f;
  display: inline-block;
  margin-bottom: calc(100vw * (6 / 375));
`
